import Edit_meta from '../page/Edit_meta.js'
import List_meta from '../page/List_meta.js'
import default_attribute from './StateDefaultAttribute.js'
import typeahead from '../components/utils/typeahead.js'

const mutations = {
  // Type

  MetaSetLoaded: function (state, params) {
    state.loaded[params.key] = params.value
  },

  SetType: function (state, type) {
    state.type = type
  },
  SetLogged: function (state, logged) {
    state.logged = logged
  },
  SetToken: function (state, token) {
    let token_parts = token.split('.')

    if (token_parts.length === 3) {
      let token_data_str = atob(token_parts[1])
      let token_data = JSON.parse(token_data_str)
      let expiration_time = Number(token_data.exp) * 1000
      let rights = Number(token_data.rights)
      let univers = Number(token_data.univers)

      state.rights = rights
      state.univers = univers
      state.token = token
    }
  },
  // SetRights: function (state, rights) {
  //   state.rights = rights
  // },
  // SetUnivers: function (state, univers) {
  //   state.univers = univers
  // },
  ListSetPagination: function (state, value) {
    state[state.type].pagination = value
  },
  ListSetSeeAll: function (state, value) {
    state[state.type].list_req.seeAll = value
  },
  ListSetReport: function (state, value) {
    state[state.type].list_req.is_report = value
  },
  ListSetLoaded: function (state, value) {
    state[state.type].loaded = value
  },
  // Data
  ListSetData: function (state, data) {
    state[state.type].items = []
    let item_id
    let item
    data.forEach(function (d, i) {
      state[state.type].items.push({
        item_id: d[0],
        selected: false,
        data: d
      })
    })
  },
  ListPushData: function (state, data) {
    let item_id
    let item
    data.forEach(function (d, i) {
      state[state.type].items.push({
        item_id: d[0],
        selected: false,
        data: d
      })
    })
  },
  // Attributes
  ListSetAttributes: function (state, attributes) {
    let id, pid, n
    state.attributes = {}

    attributes.forEach(function (item) {
      id = item.id
      pid = item.pid
      n = item.n

      state.attributes[id] = default_attribute()

      state.attributes[id].n = n
      state.attributes[id].id = id

      if (!state.attributes[pid]) {
        state.attributes[pid] = default_attribute()
      }

      state.attributes[pid].children.push(state.attributes[id])
    })
  },
  // ListSetAttribute: function (state, params) {
  //   let id = params.id
  //   let n = params.n

  //   if (!state.attributes[id]) {
  //     state.attributes[id] = default_attribute()
  //   }

  //   state.attributes[id].n = n
  //   state.attributes[id].id = id
  // },
  // ListSetAttributeChild: function (state, params) {
  //   let id = params.id
  //   let pid = params.pid

  //   if (!state.attributes[pid]) {
  //     state.attributes[pid] = default_attribute()
  //   }

  //   state.attributes[pid].children.push(state.attributes[id])
  // },
  // group menu bulk action
  ListSetMenuGroupTypeId: function (state, type_id) {
    state[state.type].menu.group.type_id = type_id
  },
  ListSetMenuGroupInput: function (state, input) {
    let group = state[state.type].menu.group
    group.input = input
  },
  ListSetMenuGroupItems: function (state, items) {
    let group = state[state.type].menu.group
    group.items = items
  },
  ListSetMenuGroupDisplay: function (state, display) {
    state[state.type].menu.group.display = display
  },
  ListSetMenuGroupValue: function (state, value) {
    state[state.type].menu.group.value = value
  },
  // Header
  ListSetHeaders: function (state, headers) {
    let sel = []
    let index = {}
    headers.forEach(function (header) {
      if (header.display || header.mandatory) {
        sel.push(header.id)
      }
      index[header.id] = header
    })
    state[state.type].headers = headers
    state[state.type].headers_index = index
    state[state.type].list_req.sel = sel
  },
  // Column sort
  ListSetHeaderSort: function (state, params) {
    let h = state[state.type].headers_index[params.id]
    let sort = state[state.type].sort
    h.sorted = params.sorted
    h.descending = params.descending
    if (params.sorted) {
      let request_sort = [[h.id, h.descending]]
      state[state.type].list_req.sort = request_sort
      state[state.type].sort = params.id
    }
    else {
      if (sort) {
        state[state.type].headers_index[sort].sorted = false
      }
      state[state.type].sort = null
    }
  },
  // Current colum sort ref for reset
  ListSetCurrentSort: function (state, current_sort) {
    state[state.type].current_sort = current_sort
  },
  ListSetHeaderDisplay: function (state, params) {
    state[state.type].headers[params.index].display = params.display
    let sel = []
    state[state.type].headers.forEach(function (header) {
      if (header.display) {
        sel.push(header.id)
      }
    })
    state[state.type].list_req.sel = sel
  },
  // Page
  ListSetPageCount: function (state, total) {
    state[state.type].pageCount = Number(total)
  },
  ListSetPage: function (state, page) {
    state[state.type].list_req.page = Number(page)
  },
  ListSetResTot: function (state, tot) {
    state[state.type].tot = Number(tot)
  },
  // Search
  ListAddSearch: function (state, search) {
    state[state.type].searchs.push(search)
    state[state.type].list_req.searchs.push(search.data)
  },
  ListDelSearch: function (state, index) {
    state[state.type].list_req.searchs.splice(index, 1)
    state[state.type].searchs.splice(index, 1)
  },
  ListSetSearch: function (state, params) {
    // console.log('state[state.type].searchs[params.index]', state[state.type].searchs[params.index])
    // state[state.type].searchs[params.index] = params.search_state
    state[state.type].list_req.searchs[params.index] = params.search_state.data

    for(var k in params.search_state) {
      state[state.type].searchs[params.index][k] = params.search_state[k]
    }
    // state[state.type].searchs[params.index] = Object.assign(
    //   state[state.type].searchs[params.index],
    //   params.search_state)
    // console.log('state[state.type].searchs[params.index]', state[state.type].searchs[params.index])
  },
  ListSetOpened: function (state, params) {
    let search = state[state.type].searchs[params.index]

    search.field_opened = false
    search.mode_opened = false
    search.type_opened = false
    search.opened = false

    switch (params.field) {
      case 'field':
        search.field_opened = true
      break
      case 'mode':
        search.mode_opened = true
      break
      case 'type':
        search.type_opened = true
      break
      case 'value':
        search.opened = true
      break
    }

  },
  ListSetSearchField: function (state, params) {
    let search = state[state.type].searchs[params.index]
    search.data.field = params.field.id
    search.text = params.fieltext
    switch (search.data.field) {
      case 'organization':
        search.display = ''
        search.id = 0
        search.items = window.orgs_index.list
        break
      case 'cat':
        search.display = ''
        search.id = 0
        search.items = window.groups_index.list
        break
      default:
        search.display = ''
        search.id = 0
        search.items = []
        break
    }
  },
  ListSetSearchFilter: function (state, params) {


    // console.log('ListSetSearchFilter', params)

    let search = state[state.type].searchs[params.index]
    let index
    let type_id
    let filter = null
    // console.log('ListSetSearchFilter', search)

    search.data.value = params.value

    if (search.data.field === 'cat') {
      index = window.groups_index
      type_id = Number(search.group_type_id)
    }
    else {
      index = window.orgs_index
      type_id = Number(search.org_type_id)
    }
    // console.log('ListSetSearchFilter', index, type_id)

    if (search.data.value === '') {
      if (type_id === 0) {
        search.items = index.list
      }
      else if (index.types &&
      index.types[type_id]) {

        let search_items = typeahead.get_display(
        // search.items = typeahead.get_display(
          index.types[type_id],
          index
        )

        search.items = search_items
        // console.log('search_items 1', search_items)
      }
    }
    else {
      if (type_id > 0) {
        filter = function (item) {
          return item.type == type_id
        }
      }

      // search.items = typeahead.filter_list(
      let search_items = typeahead.filter_list(
        params.value,
        index,
        null,
        filter
      )

      search.items = search_items
    }
  },
  ListSetSearchMode: function (state, params) {
    let search = state[state.type].searchs[params.index]
    search.data.mode = params.mode.id
  },
  ListSetSearchId: function (state, params) {
    let search = state[state.type].searchs[params.index]
    search.id = params.id
  },
  ListSetSearchValue: function (state, params) {
    let search = state[state.type].searchs[params.index]
    search.data.value = params.value
  },
  ListSetSearchType: function (state, type) {
    state[state.type].list_req.type = type
  },
  ListSetSearchGroupType: function (state, params) {
    let search = state[state.type].searchs[params.index]
    let input = search.data.value
    let type = Number(params.value)
    let index = window.groups_index
    let filter = null
    search.group_type_id = type

    if (input === '') {
      if (Number(type) === 0) {
        search.items = index.list
      }
      else if (index.types[type]) {
        search.items = typeahead.get_display(
          index.types[type],
          index
        )
      }
      else {
        search.items = []
      }
    }
    else {
      if (type > 0) {
        filter = function (item) {
          return item.type == type
        }
      }

      search.items = typeahead.filter_list(
        input,
        index,
        null,
        filter
      )
    }
  },
  ListSetSearchOrgType: function (state, params) {
    let search = state[state.type].searchs[params.index]
    let input = search.data.value
    let type = Number(params.value)
    let index = window.orgs_index
    let filter = null
    search.org_type_id = type

    if (input === '') {
      if (Number(type) === 0) {
        search.items = index.list
      }
      else if (index.types[type]) {
        search.items = typeahead.get_display(
          index.types[type],
          index
        )
      }
      else {
        search.items = []
      }
    }
    else {
      if (type > 0) {
        filter = function (item) {
          return item.type == type
        }
      }

      search.items = typeahead.filter_list(
        input,
        index,
        null,
        filter
      )
    }
  },
  ListSetSearchOrgRole: function (state, params) {
    let search = state[state.type].searchs[params.index]
    let input = search.data.value
    let type = Number(params.value)
    let index = window.orgs_index
    let filter = null
    search.org_type_id = type

    if (input === '') {
      if (Number(type) === 0) {
        search.items = index.list
      }
      else if (index.types[type]) {
        search.items = typeahead.get_display(
          index.types[type],
          index
        )
      }
      else {
        search.items = []
      }
    }
    else {
      if (type > 0) {
        filter = function (item) {
          return item.type == type
        }
      }

      search.items = typeahead.filter_list(
        input,
        index,
        null,
        filter
      )
    }
  },

  // Action

  ListAddAction: function (state, action) {
    state[state.type].actions.push(action)
    state[state.type].action_req.actions.push(action.data)
  },
  ListDelAction: function (state, index) {
    state[state.type].action_req.actions.splice(index, 1)
    state[state.type].actions.splice(index, 1)
  },
  ListSetAction: function (state, params) {
    state[state.type].actions[params.index] = params.action_state
    state[state.type].action_req.actions[params.index] = params.action_state.data
  },
  ListSetActionLabel: function (state, params) {
    state[state.type].actions[params.index].data.action = params.action
  },
  ListSetActionObject: function (state, params) {
    let type_id = Number(params.data_type_id)
    let action = state[state.type].actions[params.index]
    action.data.data_type_id = type_id
    action.type_id = 0
    action.input = ''

    switch (type_id) {
      case 7:
        action.display = ''
        action.data_id = 0
        action.items = window.groups_index.list
        break
      case 8:
        action.display = ''
        action.data_id = 0
        action.items = window.orgs_index.list
        break
    }
  },
  ListSetActionType: function (state, params) {
    let action = state[state.type].actions[params.index]
    let data_type_id = Number(action.data.data_type_id)
    let type_id = Number(params.type_id)
    let index
    let filter = null
    let items
    action.type_id = type_id

    switch (data_type_id) {
      case 7:
        action.display = ''
        action.data_id = 0
        action.items = window.groups_index.list
        index = window.groups_index
        break
      case 8:
        action.display = ''
        action.data_id = 0
        action.items = window.orgs_index.list
        index = window.orgs_index
        break
    }

    if (action.input === '') {
      if (type_id === 0) {
        items = index
      }
      else if (index.types[type_id]) {
        items = typeahead.get_display(
          index.types[type_id],
          index
        )
      }
      else {
        items = []
      }
    }
    else {
      if (type_id > 0) {
        filter = function (item) {
          return item.type === type_id
        }
      }

      items = typeahead.filter_list(
        action.input,
        index,
        null,
        filter
      )
    }
    action.items = items
  },
  ListSetActionFilter: function (state, params) {
    let action = state[state.type].actions[params.index]
    let data_type_id = Number(action.data.data_type_id)
    let type_id = Number(action.type_id)
    let index
    let filter = null
    action.input = params.value

    switch (data_type_id) {
      case 7:
        index = window.groups_index
        break
      case 8:
        index = window.orgs_index
        break
    }

    if (type_id > 0) {
      filter = function (item) {
        // console.log(item.type, type_id)
        return item.type === type_id
      }
    }

    action.items = typeahead.filter_list(
      params.value,
      index,
      null,
      filter
    )
  },
  ListSetActionValue: function (state, params) {
    let action = state[state.type].actions[params.index]
    action.data.data_id = params.data_id
    action.type_id = params.type_id
    action.display = params.display
  },
  ListSetActionMode: function (state, mode) {
    state[state.type].action_req.mode = mode
  },
  ListSetActionModalState: function (state, value) {
    state[state.type].action_modal_state = value
  },

  // Export
  ListSetExportMode: function (state, mode) {
    state[state.type].export_mode = mode
  },
  ListSetExportModalState: function (state, value) {
    state[state.type].export_modal_state = value
  },

  // Carnet
  SetUnivers: function (state, univers) {
    state.univers = univers
  },
  ListSetUniversAction: function (state, action) {
    state[state.type].univers_action = action
  },
  ListSetUniversMode: function (state, mode) {
    state[state.type].univers_mode = mode
  },
  ListSetUniversModalState: function (state, value) {
    state[state.type].univers_modal_state = value
  },

  ListSetUniversSingleModalState: function (state, value) {
    state[state.type].univers_single_modal_state = value
  },
  ListSetUniversSingleAction: function (state, value) {
    state[state.type].univers_single_action = value
  },

  // Merge

  ListSetMergeItems: function (state, items) {
    state[state.type].merge_items = items
  },
  ListSetMergeMainId: function (state, mainId) {
    state[state.type].merge_main_id = mainId
  },
  ListSetMergeModalState: function (state, value) {
    state[state.type].merge_modal_state = value
  },

  // Selection

  ListResetSelect: function (state) {
    state[state.type].all_selected = false
    state[state.type].selected.splice(0, state[state.type].selected.length)
  },
  ListSetItemSelect: function (state, params) {
    let item_id = Number(params.item.item_id)
    params.item.selected = params.selected

    if (params.selected) {
      state[state.type].selected.push(item_id)
    }
    else {
      let item_index = state[state.type].selected.indexOf(item_id)
      state[state.type].selected.splice(item_index, 1)
      state[state.type].all_selected = false
    }
  },
  // ListSetSelected: function (state, params) {
  //   let item_id = Number(params.item.item_id)
  //   let state_selected = state[state.type].selected
  //   params.item.selected = params.selected

  //   if (params.selected) {
  //     state[state.type].selected.push(item_id)
  //   }
  //   else {
  //     let item_index = state[state.type].select.indexOf(item_id)
  //     state[state.type].selected.splice(item_index, 1)
  //     state[state.type].all_selected = false
  //   }
  // },
  ListSetAllItemSelect: function (state, params) {
    state[state.type].all_selected = params.selected
    if (params.selected) {
      state[state.type].items.forEach(function (item) {
        item.selected = params.selected
        state[state.type].selected.push(Number(item.item_id))
      })
    }
    else {
      state[state.type].selected.splice(0, state[state.type].selected.length)
      state[state.type].items.forEach(function (item) {
        item.selected = params.selected
      })
    }
  },

/*** Edit ***/ //pas utilisé il me semble ...

  EditReset: function (state, type) {
    state.contactEdit = Edit_meta.full_blank_state(type)
  },
  EditNew: function (state, type) {
    state.contactEdit = Edit_meta.full_blank_state(type)
    state.contactEdit.emails = [Edit_meta.blank_states.emails()]
    state.contactEdit.addresses = [Edit_meta.blank_states.addresses()]
    state.contactEdit.phones = [Edit_meta.blank_states.phones()]
    state.contactEdit.websites = [Edit_meta.blank_states.websites()]
    state.contactEdit.groups = [Edit_meta.blank_states.groups()]
    state.contactEdit.organizations = [Edit_meta.blank_states.organizations()]
  },
  // Set
  EditSet: function (state, params) {
    state.contactEdit[params.key] = params.val
  },
  // Organization services
  SetServices: function (state, services) {
    state.services = services
  },
  AddService: function (state, params) {
    let org_id = params.org_id
    state.services[org_id] = state.services[org_id] || []
    state.services[org_id].push({
      data: params.data
    })
  },
  DelService: function (state, params) {
    let org_id = params.org_id
    state.services[org_id].splice(params.index, 1)
  },
  ConfigSetAccounts: function (state, accounts) {
    state.accounts = accounts
  },
  SetAuthPageUrl: function (state, url) {
    state.auth_page_url = url
  },
  SetOrgsIndex: function (state, index) {
    state.orgs_index = index
  },
  SetGroupsIndex: function (state, index) {
    state.groups_index = index
  },
}

export default mutations
